import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
export function AskTheCoach() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      {/* Floating Button */}
      <motion.div initial={{
      scale: 0,
      opacity: 0
    }} animate={{
      scale: 1,
      opacity: 1
    }} transition={{
      delay: 1,
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-6 right-6 z-50" data-id="element-17">
        <motion.button onClick={() => setIsOpen(!isOpen)} className="relative group" whileHover={{
        scale: 1.05
      }} whileTap={{
        scale: 0.95
      }} data-id="element-18">
          {/* Pulse Ring Animation */}
          <motion.div className="absolute inset-0 rounded-full bg-[#dc2626]" animate={{
          scale: [1, 1.3, 1],
          opacity: [0.5, 0, 0.5]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} data-id="element-19" />

          {/* Main Button */}
          <div className="relative bg-gradient-to-br from-[#dc2626] to-[#b91c1c] text-white rounded-full shadow-2xl shadow-red-500/50 p-4 flex items-center gap-3 pr-6" data-id="element-20">
            <div className="relative" data-id="element-21">
              <MessageCircle className="w-6 h-6" data-id="element-22" />
              {/* Online Indicator */}
              <motion.div className="absolute -top-1 -right-1 w-3 h-3 bg-green-400 rounded-full border-2 border-white" animate={{
              scale: [1, 1.2, 1]
            }} transition={{
              duration: 1.5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-23" />
            </div>
            <div className="hidden sm:block" data-id="element-24">
              <div className="text-sm font-bold leading-tight" data-id="element-25">
                Ask the Coach
              </div>
              <div className="text-xs text-red-100" data-id="element-26">We're online!</div>
            </div>
          </div>
        </motion.button>
      </motion.div>

      {/* Chat Window */}
      <AnimatePresence data-id="element-27">
        {isOpen && <motion.div initial={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="fixed bottom-24 right-6 z-50 w-[90vw] sm:w-96 bg-white rounded-2xl shadow-2xl overflow-hidden" data-id="element-28">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#1e3a8a] to-[#1e40af] text-white p-4 flex items-center justify-between" data-id="element-29">
              <div className="flex items-center gap-3" data-id="element-30">
                <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center" data-id="element-31">
                  <MessageCircle className="w-5 h-5" data-id="element-32" />
                </div>
                <div data-id="element-33">
                  <div className="font-bold" data-id="element-34">Master Joe</div>
                  <div className="text-xs text-blue-100 flex items-center gap-1" data-id="element-35">
                    <div className="w-2 h-2 bg-green-400 rounded-full" data-id="element-36"></div>
                    Online now
                  </div>
                </div>
              </div>
              <button onClick={() => setIsOpen(false)} className="text-white/80 hover:text-white transition-colors" data-id="element-37">
                <X className="w-5 h-5" data-id="element-38" />
              </button>
            </div>

            {/* Chat Content */}
            <div className="p-6 bg-gray-50 h-64 overflow-y-auto" data-id="element-39">
              <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="bg-white rounded-2xl rounded-tl-none p-4 shadow-sm mb-4 max-w-[85%]" data-id="element-40">
                <p className="text-gray-800 text-sm leading-relaxed" data-id="element-41">
                  👋 Hi! I'm Master Joe. Have questions about our programs or
                  want to schedule a trial class?
                </p>
              </motion.div>

              <motion.div initial={{
            opacity: 0,
            y: 10
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.4
          }} className="bg-white rounded-2xl rounded-tl-none p-4 shadow-sm max-w-[85%]" data-id="element-42">
                <p className="text-gray-800 text-sm leading-relaxed mb-3" data-id="element-43">
                  I'm here to help! What would you like to know?
                </p>
                <div className="space-y-2" data-id="element-44">
                  <button className="w-full text-left px-3 py-2 bg-blue-50 hover:bg-blue-100 text-[#1e3a8a] rounded-lg text-sm font-medium transition-colors" data-id="element-45">
                    📅 Schedule a trial class
                  </button>
                  <button className="w-full text-left px-3 py-2 bg-blue-50 hover:bg-blue-100 text-[#1e3a8a] rounded-lg text-sm font-medium transition-colors" data-id="element-46">
                    💰 Learn about pricing
                  </button>
                  <button className="w-full text-left px-3 py-2 bg-blue-50 hover:bg-blue-100 text-[#1e3a8a] rounded-lg text-sm font-medium transition-colors" data-id="element-47">
                    🥋 View class schedules
                  </button>
                </div>
              </motion.div>
            </div>

            {/* Input Area */}
            <div className="p-4 bg-white border-t border-gray-100" data-id="element-48">
              <div className="flex gap-2" data-id="element-49">
                <input type="text" placeholder="Type your message..." className="flex-1 px-4 py-2 border border-gray-200 rounded-full focus:outline-none focus:ring-2 focus:ring-[#1e3a8a] focus:border-transparent text-sm" data-id="element-50" />
                <button className="bg-[#dc2626] text-white p-2 rounded-full hover:bg-red-700 transition-colors" data-id="element-51">
                  <MessageCircle className="w-5 h-5" data-id="element-52" />
                </button>
              </div>
              <p className="text-xs text-gray-400 mt-2 text-center" data-id="element-53">
                Typically replies within minutes
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}